import React from "react";
import Banner from "../../Assets/Images/Banner.png";

const SimpleBanner = ({ name_primary, name_secondary, path }) => {
  return (
    <div
      className="relative h-[100px] md:h-[200px] bg-cover bg-no-repeat bg-left"
      style={{ backgroundImage: `url(${Banner})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#0d0d0d]/10 flex flex-col items-center justify-center px-4 text-white">
        {/* Heading */}
        <h1 className="font-montserrat font-semibold text-[24px] md:text-[36px] leading-[38px] md:leading-[55px] tracking-[0.5%] capitalize text-center">
          <span className="text-primaryOrange mr-3">{name_primary}</span>
          <span>{name_secondary}</span>
        </h1>

        {/* Path */}
        <p className="font-montserrat tracking-wide mt-2 text-[14px] md:text-[16px] capitalize text-center">
          {path}
        </p>
      </div>
    </div>
  );
};

export default SimpleBanner;
